import { frontendURL } from 'dashboard/helper/URLHelper';
import DashboardAppPage from './pages/DashboardAppPage.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/apps/:appId'),
    name: 'wasapi_dashboard_app',
    component: DashboardAppPage,
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
  },
];
